var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWheat = function SvgWheat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15.018 26.891v-4.687M7.413 11.879l-.538 2.005a6.23 6.23 0 0 0 4.405 7.631q1.869.503 3.738 1.001v-4.3a6.225 6.225 0 0 0-4.595-5.532z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.18 13.953a6.125 6.125 0 0 0 1.327-6.666 6.1 6.1 0 0 0-1.327-1.984l-2.162-2.162-2.163 2.162a6.13 6.13 0 0 0-1.791 4.325c0 1.622.645 3.178 1.791 4.325"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m22.624 11.879.537 2.005a6.233 6.233 0 0 1-4.406 7.631l-3.737 1.001v-4.3a6.225 6.225 0 0 1 4.596-5.532z"
  })));
};
export default SvgWheat;